(function(additionalModules){
    'use strict';

    var app = angular.module('admin',
        [
            'ngRoute',
            'oc.lazyLoad',
            'vvCommon',
            'plupload.directive',
            'minicolors',
            'gettext',
            'ngCookies',
            'ngSanitize',
            'ngS3upload',
            'ngOssUpload',
            'selectize',
            'ui.bootstrap',
            'hljs',
            'ngAnimate',
            'vvTaskUtil',
        ].concat(additionalModules)
    );

    app.run(function($rootScope, vv) {
      $rootScope.isHqSvc = vv.getVvMetaData('is_hq_svc');
    });

    app.config(function($provide) {
        $provide.decorator('$exceptionHandler', ['$delegate', function($delegate) {
            return function(exception, cause) {
                window._report_error(exception);
                $delegate(exception, cause);
            };
        }]);
    });

})(document.ADMIN_MODULES || []);
